import {post, get} from '@/lib/axios';
import router from '../../router';

const registration = {
  async register(id, form) {
    const res = await post(`/register_event/${id}`, form);
    return res;
  },
};

export {registration as default};
